module.exports = __webpack_public_path__ + "static/media/cdb5.7c600f92.png";